/**
 * `isDevelopment` flag derived from `__DEV__` and `NODE_ENV`.
 *
 * Single boolean, no runtime behavior. Centralized so dev-only branches share
 * one definition rather than each module re-deriving the check.
 */

export const isDevelopment = __DEV__ || process.env.NODE_ENV === 'development';
